// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/rc/ReportingCentre"),
  orderPrio: 60,
  iconType: "trademark",
  name: "rc",
  subApps: [
    {
      name: "tax-agency",
      requirePermission: "rc:tax-agency"
    },
    {
      name: "digitax",
      requirePermission: "digitax:incident-view"
    },
    {
      name: "manage-vehicles",
      requirePermission: ["rc:view-vehicle", "rc:list-vehicles"]
    },
    {
      name: "manage-organizations",
      requirePermission: "rc:view-organization"
    }
  ]
}: AppType)
